import { useEffect, useState } from "react";
import { getProductionFrequentPicks } from "../api/client";

/**
 * پرتکرارهای تولید — یک‌بار در هر بارگذاریِ صفحه گرفته می‌شود و بینِ همهٔ
 * مصرف‌کننده‌ها مشترک است.
 *
 * چرا کش در سطحِ ماژول: این داده در طولِ یک نشست عملاً ثابت است و چند کامپوننت
 * (گریدِ عملیات، برگهٔ ثبت، ویرایش) هم‌زمان لازمش دارند. بدونِ کش، هر بار
 * بازکردنِ یک پارت یک درخواستِ تازه می‌زد.
 */
let cache = null;
let inflight = null;

export function invalidateFrequentPicks() { cache = null; inflight = null; }

export default function useFrequentPicks() {
  const [data, setData] = useState(cache);

  useEffect(() => {
    let alive = true;
    if (cache) { setData(cache); return () => { alive = false; }; }
    if (!inflight) {
      inflight = getProductionFrequentPicks()
        .then((r) => { cache = r.data; return cache; })
        // شکستش نباید چیزی را بشکند: نبودِ «پرتکرار» فقط یعنی فهرستِ عادی
        .catch(() => { cache = { employees_by_operation: {}, operations_by_product: {} }; return cache; })
        .finally(() => { inflight = null; });
    }
    inflight.then((d) => { if (alive) setData(d); });
    return () => { alive = false; };
  }, []);

  return data || { employees_by_operation: {}, operations_by_product: {} };
}
